import React, { useMemo } from 'react';
import { SearchRecord } from 'types/record';
import { Search } from 'types/search';
import { useReportSelector } from 'components/ReportPage/ReportContext';
import {
  allSearchRecords,
  formatSearchTitle,
  getChargeTitle,
  getChargeDate,
} from '../../../../../../lib/screenings';
import { getRequestedRecords } from '../../../../../helpers';
import CandidateStoriesMultiSelect from './CandidateStoriesMultiSelect';
import { useCandidateStoryFormContext } from '../Context';

type Props = {
  search: Search;
  toggleRecord: (value: SearchRecord) => void;
  selectedRecords: SearchRecord[];
};

const ChargesByRecordForm = ({
  search,
  toggleRecord,
  selectedRecords,
}: Props) => {
  const accountId = useReportSelector(state => state?.account?.id);

  const { chargeSelectionEnabled, requestedItems } =
    useCandidateStoryFormContext();
  const recordSelected = (recordId: string) => {
    return !!selectedRecords.find((item: SearchRecord) => item.id === recordId);
  };
  const displayedRecords = useMemo(() => {
    return chargeSelectionEnabled
      ? allSearchRecords(search)
      : getRequestedRecords(search, requestedItems);
  }, [chargeSelectionEnabled, search, requestedItems]);

  if (displayedRecords.length === 0) {
    return null;
  }

  return (
    <div className='mb-4' data-testid='charges-by-record-form'>
      <div className='mb-2'>
        <b>{formatSearchTitle(search, accountId)}</b>
      </div>
      <div className='form-group'>
        {displayedRecords.map((record: SearchRecord) => (
          <CandidateStoriesMultiSelect
            key={record.id}
            displayValue={getChargeTitle(record)}
            selectValue={record}
            toggleValue={toggleRecord}
            date={getChargeDate(record)}
            selected={recordSelected(record.id)}
            disabled={!chargeSelectionEnabled}
          />
        ))}
      </div>
    </div>
  );
};

export default ChargesByRecordForm;
